<div class="banner-area-two banner-area-three">
    <div class="hero-slides" aria-hidden="true">
        <div class="hero-slide" *ngFor="let slide of heroSlides; let i = index"
            [class.is-active]="activeHeroSlide === i">
            <img [src]="slide.image" alt="" loading="eager"
                [attr.fetchpriority]="i === 0 ? 'high' : null">
        </div>
    </div>

    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="banner-content">
                    <h1 aria-label="Simple Things Make The Greatest Scenes">Simple Things Make The Greatest Scenes</h1>
                </div>
            </div>
        </div>
    </div>

    <div class="banner-social">
        <span aria-hidden="true">Follow us on:</span>

        <ul aria-label="Social links">
            <li>
                <a href="https://www.facebook.com/share/14qgMUQSAZo/?mibextid=wwXIfr" target="_blank"
                    aria-label="Facebook" title="Facebook"><i class="bx bxl-facebook"></i></a>
            </li>
            <li>
                <a href="https://www.instagram.com/blinkproductions_?stkn=a2M4cDNrcmo0ZWdh&utm_source=qr"
                    target="_blank" aria-label="Instagram" title="Instagram"><i class="bx bxl-instagram"></i></a>
            </li>
        </ul>
    </div>

    <div class="hero-slider-controls" role="group" aria-label="Hero slideshow controls">
        <button class="hero-slider-arrow" type="button" (click)="previousHeroSlide()"
            aria-label="Previous slide">
            <i class="bx bx-chevron-left" aria-hidden="true"></i>
        </button>
        <div class="hero-slider-dots">
            <button *ngFor="let slide of heroSlides; let i = index" type="button"
                class="hero-slider-dot" [class.is-active]="activeHeroSlide === i"
                [attr.aria-label]="'Show slide ' + (i + 1)"
                [attr.aria-pressed]="activeHeroSlide === i"
                (click)="selectHeroSlide(i)">
                <span></span>
            </button>
        </div>
        <button class="hero-slider-arrow" type="button" (click)="nextHeroSlide()"
            aria-label="Next slide">
            <i class="bx bx-chevron-right" aria-hidden="true"></i>
        </button>
        <button class="hero-slider-pause" type="button" (click)="toggleHeroAutoplay()"
            [attr.aria-label]="heroAutoplayPaused ? 'Play slideshow' : 'Pause slideshow'">
            <i [class]="heroAutoplayPaused ? 'bx bx-play' : 'bx bx-pause'" aria-hidden="true"></i>
        </button>
    </div>

    <div class="lines">
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
    </div>
</div>

<section class="product-area product-area-two pt-100 pb-70 home-section home-intro-section">
    <div class="container">
        <div class="section-title" appReveal>
            <h2>BLINK PRODUCTIONS</h2>
        </div>

        <div *ngIf="productionsLoading" class="row">
            <div class="product-item-container col-sm-6 col-lg-4" *ngFor="let item of productionSkeletonItems">
                <div class="product-item skeleton">
                    <div class="product-item-image-skeleton"></div>
                    <h3 class="skeleton-text skeleton-title">&nbsp;</h3>
                    <p class="skeleton-text skeleton-desc">&nbsp;</p>
                </div>
            </div>
        </div>

        <div *ngIf="!productionsLoading && productionsError" class="row">
            <div class="col-12">
                <div class="service-feedback service-error">
                    <strong>Unable to load Blink Productions content.</strong>
                    <span>{{ productionsError }}</span>
                </div>
            </div>
        </div>

        <div *ngIf="!productionsLoading && !productionsError && productions.length === 0" class="row">
            <div class="col-12">
                <div class="service-feedback service-empty">
                    No Blink Productions items were returned from WordPress. Add items under WordPress and refresh this
                    page.
                </div>
            </div>
        </div>

        <div class="row" *ngIf="!productionsLoading && !productionsError && productions.length > 0">
            <div class="product-item-container col-sm-6 col-lg-4"
                [class.offset-sm-3]="needsSmOffset(i, productions.length)"
                [class.offset-lg-0]="needsSmOffset(i, productions.length)"
                *ngFor="let item of productions; trackBy: trackByProduction; let i = index" appReveal
                revealVariant="card" [revealDelay]="i * 100">
                <div class="product-item">
                    <img *ngIf="item.imageUrl" [src]="item.imageUrl" [alt]="item.imageAlt" loading="lazy" />
                    <h3>{{ item.title }}</h3>
                    <p *ngIf="item.description">{{ item.description }}</p>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="service-area service-area-two pt-100 pb-70 home-section home-services-section">
    <div class="container">
        <div class="section-title" appReveal>
            <h2>Our Services</h2>
        </div>

        <div *ngIf="loading" class="row">
            <div class="col-sm-6 col-lg-4" *ngFor="let item of skeletonItems">
                <div class="service-item skeleton">
                    <i class="bx bx-loader-alt"></i>
                    <div class="service-inner">
                        <h3 class="skeleton-text skeleton-title">&nbsp;</h3>
                        <p class="skeleton-text skeleton-desc">&nbsp;</p>
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="!loading && error" class="row">
            <div class="col-12">
                <div class="service-feedback service-error">
                    <strong>Unable to load services.</strong>
                    <span>{{ error }}</span>
                </div>
            </div>
        </div>

        <div *ngIf="!loading && !error && services.length === 0" class="row">
            <div class="col-12">
                <div class="service-feedback service-empty">
                    No services were returned from WordPress. Add services under WordPress and refresh this page.
                </div>
            </div>
        </div>

        <div class="row" *ngIf="!loading && !error && services.length > 0">
            <div class="col-sm-6 col-lg-4" *ngFor="let service of services; trackBy: trackByService; let i = index"
                appReveal revealVariant="card" [revealDelay]="i * 85">
                <div class="service-item">
                    <img *ngIf="service.imageUrl; else serviceFallbackIcon" [src]="service.imageUrl"
                        [alt]="service.title" class="service-icon-img">
                    <ng-template #serviceFallbackIcon><i [ngClass]="fallbackServiceIcon"></i></ng-template>
                    <div class="service-inner">
                        <h3>{{ service.title }}</h3>
                        <p *ngIf="service.description">{{ service.description }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="testimonial-area ptb-100 home-section home-clients-section">
    <div class="container">
        <div class="section-title section-title-two" appReveal>
            <h2>Our Clients</h2>
        </div>

        <div *ngIf="clientsLoading" class="client-logo-grid" aria-label="Loading client logos">
            <div class="client-logo-skeleton" *ngFor="let item of clientSkeletonItems"></div>
        </div>

        <div *ngIf="!clientsLoading && clientsError" class="client-feedback client-error">
            <strong>Unable to load clients.</strong>
            <span>{{ clientsError }}</span>
        </div>

        <div *ngIf="!clientsLoading && !clientsError && clients.length === 0" class="client-feedback client-empty">
            No client logos were returned from WordPress. Add a published Our Clients item with a Client Logo 1 image
            and refresh this page.
        </div>

        <div *ngIf="!clientsLoading && !clientsError && clients.length > 0" class="client-logo-grid">
            <div class="client-logo-card" *ngFor="let client of clients; trackBy: trackByClient; let i = index"
                appReveal revealVariant="scale" [revealDelay]="i * 70">
                <ng-container *ngIf="client.link; else plainLogo">
                    <a [href]="client.link" target="_blank" rel="noopener" aria-label="{{ client.title }}">
                        <img [src]="client.imageUrl" [alt]="client.alt" loading="lazy" />
                    </a>
                </ng-container>
                <ng-template #plainLogo>
                    <img [src]="client.imageUrl" [alt]="client.alt" loading="lazy" />
                </ng-template>
            </div>
        </div>
    </div>
</section>